module.exports = __webpack_public_path__ + "img/flight-IW-wings-circle.a4612703.svg";